/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-observers, ember/no-runloop, ember/require-computed-property-dependencies, no-prototype-builtins */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import { debounce } from '@ember/runloop';
import { observes } from '@ember-decorators/object';
import { filterBy } from '@linc-technologies/linced-common/utils/arrays';

export default class FamilyDirectoryController extends Controller {
  title = 'Family Directory';

  // siblingsChanged and siblingChanges are used to debounce recomputing the `families`
  // structure, as otherwise it would recompute a large number of times as each student's
  // `currentSiblings` computed property does its thing.
  @observes('model.learners.@each.currentSiblings')
  siblingsChanged() {
    debounce(this, 'incrementProperty', 'siblingChanges', 250);
  }

  @tracked siblingChanges = 0;

  @computed('siblingChanges', 'sortProp', 'sortDir')
  get families() {
    let families = [];
    let processed = {};

    this.model.learners.forEach((person) => {
      if (processed.hasOwnProperty(person.id)) {
        return;
      }

      let family = {
        surname: person.lastName,
        siblings: [person],
      };

      processed[person.id] = true;

      filterBy(person.learner.currentSiblings, 'person').forEach((sibling) => {
        processed[sibling.personId] = true;
        family.siblings.push(sibling.person);
      });

      family.contacts = person.learner.primaryContacts.slice(0, 2);

      families.push(family);
    });

    return families;
  }
}
